/**
 * Given a DOM `HTMLElement` and a direction, determines if the element can be scrolled in that direction.
 * If the element has already been scrolled all the way to
 * @param element - HTML Element
 * @param direction - direction string
 * @returns
 */
export const isScrollableInDirection = (
  element: HTMLElement,
  direction: 'up' | 'down' | 'left' | 'right'
) => {
  let currentScroll: number;
  if (direction === 'up' || direction === 'down') {
    currentScroll = element.scrollTop || 0;
  } else {
    currentScroll = element.scrollLeft || 0;
  }

  // Check if the element can be scrolled in the specified direction
  switch (direction) {
    case 'up':
    case 'left':
      return currentScroll > 0;
    case 'down':
    case 'right': {
      const scrollDimensionKey =
        direction === 'down' ? 'scrollHeight' : 'scrollWidth';
      const clientDimensionKey =
        direction === 'down' ? 'clientHeight' : 'clientWidth';

      const maxScroll =
        element[scrollDimensionKey] - element[clientDimensionKey];
      return currentScroll < maxScroll;
    }
  }
};
